import type { CSSProperties } from 'react';

import type { LcvModelColor } from '@/types/tis-cms/types';

export type ColorListItem = LcvModelColor;

export type InteriorSwatchColor = {
  colorCodePrimary?: string | null;
  colorCodeSecondary?: string | null;
};

export const getLcvColorId = (modelColor?: ColorListItem | null) =>
  modelColor?.color?.title ?? '';

export const getLcvColorHex = (modelColor: ColorListItem) => {
  const colorCode = modelColor.color?.colorCode?.trim() ?? '';
  if (!colorCode) return '';
  return colorCode.startsWith('#') ? colorCode : `#${colorCode}`;
};

export const getLcvColorNameTh = (modelColor: ColorListItem) =>
  modelColor.color?.nameTh ?? '';

/** Base fill only — sheen is the Figma SVG radial (rotated) layered on top. */
export const getInteriorSwatchStyle = (
  interiorColor?: InteriorSwatchColor | null,
  fallbackColor = '#383838'
): CSSProperties => {
  if (!interiorColor?.colorCodePrimary) {
    return { background: fallbackColor };
  }

  if (interiorColor.colorCodeSecondary) {
    return {
      background: `linear-gradient(315deg, ${interiorColor.colorCodePrimary} 50%, ${interiorColor.colorCodeSecondary} 50%)`,
    };
  }

  return { background: interiorColor.colorCodePrimary };
};
